import { cn } from "@/lib/utils";

interface SimpleLinkProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: React.ReactNode;
  disabled?: boolean;
}

const SimpleLink = ({ children, ...props }: SimpleLinkProps) => {
  const { className, ...rest } = props;
  return (
    <a
      {...rest}
      className={cn(
        `cursor-pointer font-semibold text-cf-foreground decoration-wavy hover:underline hover:underline-offset-4 ${
          props.disabled ? "pointer-events-none text-muted-foreground" : ""
        }`,
        className,
      )}
    >
      {children}
    </a>
  );
};

export { SimpleLink };
